import { environment } from '../../environments/environment';

export const SERVICE_URL = {
    CRYPTO_JWKS: 'api/crypto/jwks',
    MASTER_CONFIG: environment.preprod
        ? 'api/admin/v1/master/config/'
        : 'api/admin/v1/master/config/',
    KEYCLOCK_SERVICE: 'api/keycloak/v2/graph/',
    KEYCLOAK_REALMS: 'api/keycloak/v1/realms/',
    PROFILE: environment.preprod
        ? 'api/profiles-preprod/v3/lokos-profile-preprod/'
        : 'api/profiles/v3/lokos-profile/',
    VAULT_PROFILE: 'api/vault/profile/v1/',
    CADRE_PROFILE: 'api/cadre-profile/v1/cadre-profile/',
    REPORTS: 'api/reports/v3/reporting/',
    REPORTS_AAJEEVIKA: 'api/reports/v3/reporting/aajeevika/',
    SPARSH: 'api/sparsh/v1/',
    TRANSACTION: 'api/transactions/v3/lokos-transaction/',
    AAJEEVIKA: 'api/lokos-aajeevika/v3/aajeevika/',
};
